import Button from "../../components/Button";
import millify from "millify";
import {IoMdHeart} from 'react-icons/io';
import {FaCommentDots} from 'react-icons/fa';
import {IoIosShareAlt} from 'react-icons/io';
import {BsMusicNoteBeamed} from 'react-icons/bs';
import ProfilePic from "../ProfilePic";


function TikTok(props) {
  const { tiktok } = props;

  return (
    <div id="TikTok" className="col-10 col-md-8 col-lg-6 row flex-row my-4">
      <div className="col-2">
      <ProfilePic
          url={require(`../../assets/img/${tiktok.profileIMG}`).default} />
      </div>
      <div className="col-8 mid">
        <p>
          <span className="fw-bold username">{tiktok.username}&nbsp;</span>
          <span>{tiktok.name}</span>
        </p>
        <p className="content">{tiktok.content}</p>
        <p className="fw-bold soundtrack">
          <BsMusicNoteBeamed size={20} /> {tiktok.soundtrack}
        </p>
        <video className="w-100 video" controls>
          <source src={require(`../../assets/video/${tiktok.video}`).default}
          alt={tiktok.title} />
        </video>
      </div>
      <div className="col-1 right">
        <Button text={"Follow"} type={"secondary"} />
        <div className="social">
          <div className="likes">

            <IoMdHeart size="24" />

            <p>{millify(tiktok.likes)}</p>
          </div>
          <div className="comments">
            
            <FaCommentDots size="20" />

            <p>{millify(tiktok.comments)}</p>
          </div>
          <div className="shares">
            
            <IoIosShareAlt size="26" />

            <p>{millify(tiktok.shares)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TikTok;